import { format, parseISO, isValid, addHours } from 'date-fns'

type DateDto = {
  day: number
  month: number
  year: number
}

export const toDateString = (date: DateDto): string => {
  const { day, month, year } = date
  return new Date(year, month, day).toISOString()
}

export const toDateDto = (date: Date | string): DateDto | null => {
  if (!date) return null
  const thisDate = new Date(date)
  return {
    day: thisDate.getDate(),
    month: thisDate.getMonth(),
    year: thisDate.getFullYear(),
  }
}

export const formatFullDate = (date: string | undefined): string => {
  if (!date) return ''
  return format(parseISO(date), 'MMMM d, yyyy')
}

export const formatDateShort = (date: string | undefined): string => {
  if (!date) return ''
  return format(parseISO(date), 'MMM d, yyyy')
}

export const formatDate = dateString => {
  if (!dateString) return null
  const formattedDate = format(new Date(dateString), 'yyyy-MM-dd')
  return formattedDate
}

export const formatDateTime = dateString => {
  if (!dateString) return null
  return format(new Date(dateString), 'MMM d @ h:mm a')
}

export const stripTime = dateString => {
  if (!dateString) return null
  return dateString.slice(0, 10)
}

export const monthYear = (date: string | undefined): string => {
  if (!date) return ''
  return format(parseISO(date), 'MMM yy')
}

export const monthDay = dateString => {
  if (!dateString) return ''
  return format(parseISO(dateString), 'MMM d')
}

export const weekdayMonthDay = dateString => {
  if (!dateString) return ''
  return format(parseISO(dateString), 'EEEE, MMMM d')
}

export const resumeDateDisplay = (date, endDate = false) => {
  if ((date === null || date === 'Present') && endDate) return 'Present'

  if (date === '' || date === undefined) return ''

  const jsDate = new Date(date)
  const validDate = date && isValid(jsDate)

  if (!validDate && !endDate) return date

  if (!validDate) return ''

  return format(addHours(jsDate, 12), 'MMM yyyy')
}

export const checkDates = (startDateString, endDateString) => {
  if (!startDateString) return true
  const startDate = new Date(startDateString)
  const endDate = endDateString ? new Date(endDateString) : new Date()
  return startDate <= endDate
}
